<style lang="scss" scoped>
.wrap-tec{
  margin-bottom: 0;
}
.cons{
  display: none;
}
.mr41{
  display: block;
}
.mr42{
  display: none;
}
  // .plat{
  //   padding:0 10%;
  // }
  .require{
    // width:980px;
    margin:0 auto;
    li{
      display: flex;
      align-items: center;
      background: #F6FAFD;
      padding:40px 60px;
      margin-bottom: 15px;
      &:last-child{
        margin-bottom: 0;
      }
      .img-box{
        text-align: center;
        width:350px;
        font-size: 20px;
        color: #014492;
        font-weight: bold;
      }
      .info{
        flex:1;
        line-height: 2;
      }
    }
  }
  .sanger-type{
    background: #F6FAFD;
    margin-top: 100px;
    padding-bottom: 80px;
    .c-title{
      padding-top: 60px;
    }
  }
  .sanger-service{
    margin-top: 60px;
    padding-bottom: 60px;
    .lists1{
      display: flex;
      justify-content: space-around;
      text-align: center;
      padding:0 100px;
      li{
        flex: none;
        width:180px;
        img{
          margin-bottom: 39px;
        }
        .fb{
          margin-bottom: 16px;
        }
        p{
          margin-bottom: 10px;
          line-height: 25px;
          text-align: justify;
        }
      }
    }
  }
  .center-text{
    text-align: center !important;
  }
  @media screen and (max-width: 640px){
    .sanger-service .lists1{
      padding:0;
    }
    .wrap-tec .effect-lists li{
      height: 140px!important;
    }
    .sanger-service .lists1 li p{
      text-align: center!important;
    }
    .mr42{
      margin-left: auto;
      margin-right: auto;
      display: block!important;
    }
    .mr41{
      display: none!important;
    }
  }
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .con{
    display: none!important;
  }
  .lists1{
    display: flex!important;
    flex-wrap: wrap;
  }
  .cons{
    display: block!important;
  }
  .effect-lists{
    display: block!important;
  }
}
</style>
<template>
  <!--Sanger测序-->
  <div class="wrap wrap-tec">
    <router-view></router-view>
    <div class="banner">
      <img src="@/assets/images/banner_4.png" class="img-fluid">
      <div class="info">
        <div class="container">
          <h1>测序找擎科速必达</h1>
          <h2>上班前出结果</h2>
          <el-button class="mt40 mr42" size="mini" @click="toOrder">立即测序</el-button>
          <el-button class="mt40 mr41"  @click="toOrder">立即测序</el-button>
        </div>
      </div>
    </div>
    <div>
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-top: 20px;">
        <bread></bread>
      </div>
      <div class="c-title">Sanger测序</div>
      <div class="container">
        <el-row type="flex" align="bottom">
          <el-col :span="12">
            <img src="@/assets/images/sanger_1.png" class="img-fluid">
          </el-col>
          <el-col :span="12">
            <div class="required">
              Sanger测序是 DNA 测序技术的“金标准”，擎科生物已为上万家科研院所、医院及工业企业提供数千万次Sanger测序服务。实验室配备百余台3730XL遗传分析仪，已实现自动化、智能化生产全覆盖，确保高测序成功率和准时性；建立了“速必达、测必成、疑必解”三大Sanger测序服务新标准。
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="sanger-type">
      <div class="c-title">测序类型</div>
      <div class="container con" style="width: 980px;">
        <ul class="effect-lists">
          <li v-for="(item, index) in types" :key="index" :class="{active: currentType === index}" @mouseover="currentType = index" @mouseout="currentType = -1">
            <img :src="`/static/images/sanger_icon${index+1}${currentType === index ? '_active':''}.png`">
            <p>{{item.name}}</p>
          </li>
        </ul>
      </div>
      <div class="container cons">
        <ul class="effect-lists">
          <li v-for="(item, index) in types" :key="index" @click="$router.push(item.ref)">
            <img :src="`/static/images/sanger_icon${index+1}${currentType === index ? '_active':''}.png`">
            <p>{{item.name}}</p>
          </li>
        </ul>
      </div>
    </div>
    <div>
      <div class="c-title">自动化生产流程</div>
      <div class="container">
        <div class="plat">
          <img src="@/assets/images/sanger_2.png" class="img-fluid">
        </div>
      </div>
    </div>
    <div>
      <div class="c-title">送样要求</div>
      <div class="container">
        <ul class="require">
          <li>
            <div class="img-box">
              <img src="/static/images/sanger_icon2.png">
              <p>菌液送样要求</p>
            </div>
            <div class="info">
              <p>1. 需培养的菌液：提供的量不少于200 μL；</p>
              <p>2. 长途运输尽量提供穿刺菌；</p>
              <p>3. 新鲜菌液易于培养，可以获得更多的DNA，同时更大限度保证菌种的纯度。</p>
              <p>4. 请标明载体名称、插入片段大小及抗性，擎科提供Amp，Kana两种抗生素</p>
              <p>5. 菌落平板，圈定待测的菌落并编号。</p>
            </div>
          </li>
          <li>
            <div class="img-box">
              <img src="/static/images/sanger_icon1.png">
              <p>PCR产物送样要求</p>
            </div>
            <div class="info">
              <p>1. 已纯化的PCR请务必溶于灭菌的双蒸水中，不少于20 μL。</p>
              <p>2. 未纯化的PCR不少于30 μL。</p>
            </div>
          </li>
          <li>
            <div class="img-box">
              <img src="/static/images/sanger_icon3.png">
              <p>质粒送样要求</p>
            </div>
            <div class="info">
              <p>1. 请务必溶于灭菌的双蒸水中。</p>
              <p>2. 检测浓度大于50 ng/μL浓度；不少于20 μL。</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div>
      <div class="c-title">测序常见问题</div>
      <div class="container container1">
        <div class="questions questions1">
          <el-collapse v-model="activeNames">
            <el-collapse-item title="Q-1.测序结果有很多套峰，还照常收费，为什么?" name="1">
              <div>DNA模板上出现二处以上引物结合位点，或者DNA模板上有严重的重复序列，以及测序引物不纯时, 测序结果便会出现套峰现象。出现这种现象的原因由DNA模板本身或者引物本身所造成，这些结果会收费。</div>
            </el-collapse-item>
            <el-collapse-item title="Q-2.为什么用PCR产物测序时，经常会出现套峰现象? 测序峰图" name="2">
              <p>PCR产物测序出现套峰现象，一般有以下几种原因：</p>
              <p>(1) PCR用模板不纯或PCR用引物特异性不好，扩增出的产物除了目的片段外，还有与目的片段长度相近的片段，即使用凝胶电泳也无法分离开，这样的PCR产物测序结果是套峰。</p>
              <p>(2) 结构上的原因，造成了PCR产物测序出现套峰的现象。PolyA/T G/C以及原因不明的复杂结构的存在，都会出现测序结果套峰的情况。</p>
            </el-collapse-item>
            <el-collapse-item title="Q-3.出现套峰的原因是什么？" name="3">
              <p>在测序反应中，模板或引物的原因都可能造成套峰的形成，归结其形成原因有以下几点：</p>
              <p>(1) 测序引物在模板上有两个结合位点形成套峰。</p>
              <p>(2) 模板不纯，如果是质粒或是菌液，原因是非单克隆，如果是PCR,原因为非特异性条带。</p>
              <p>(3) 模板序列的特殊结构，如poly结构、发卡结构等。</p>
            </el-collapse-item>
            <el-collapse-item title="Q-4.测序结果不到800 Bases，还照常收费了，为什么?" name="4">
              <p>如在DNA样品中的DNA序列分布匀称，没有复杂结构时，正常的测序反应能保证达到800 Bases以上。但有一些DNA样品立体结构复杂，造成聚合酶延伸反应终止，测序信号突然减弱或消失，或者测序结果出现套峰现象。出现这些现象的原因由DNA模板本身所造成。 对这些结果，公司会根据具体测序情况进行收费。出现这些情况的原因分析如下：</p>
              <p>(1) G/C rich、G/C Cluster：这种情况一般表现为测序信号突然减弱或消失；测序峰图</p>
              <p>(2) A、T的连续结构：这种情况一般表现为A、T连续结构后面的测序结果出现套峰。根据文献记载，原因在于聚合酶进行聚合反应时，由于A或T的连续，聚合酶难以识别完整的每个A或T，在某个A或T的后面便开始进行A或T连续结构以后序列的聚合反应（打滑现象），造成测序结果紊乱，出现套峰。出现这样的情况，建议反向测序。</p>
              <p>(3) 原因不明的复杂结构，测序结果出现突然信号减弱或消失。从序列上看，DNA碱基排列并无特别异常。估计是DNA整体出现复杂结构，从某一位置开始聚合酶的聚合反应便无法进行。</p>
            </el-collapse-item>
            <el-collapse-item title="Q-5.觉得你给我的结果完全不是我需要的序列？" name="5">
              <p>出现这样的情况只有两种可能：</p>
              <p>(1) 可能是空载体,没有装进去目的片段。</p>
              <p>(2) 您的样品插入部分与您预期的不一致。我们无法判断测得的序列是否与您预期的结果一致，我们可以为您做的是，检查发送给您的测序结果与您提供来的样品是否一致。出现您这样的问题，我们常规的做法是进行验证实验。验证实验的方法是取您的原始菌液重新抽提质粒进行测序。验证实验如在可靠范围内结果与前次不同则说明我们前次的测序结果是有问题的，前次测序的费用免除；如结果仍然相同，那么说明前次测序的结果准确，则您还需要支付这一次测序的费用。</p>
            </el-collapse-item>
            <el-collapse-item title="Q-6.测序结果的找不到引物序列？" name="6">
              <p>(1) 如果您提供的是PCR样品，在测序报告上找不到您的引物序列是正常的。这是因为测序反应是通过对被荧光标记的ddNTP的读取而获得基因序列的，而测序引物由于没 有荧光标记，因此自然在测序结果中就不会被识别。实际上不但测序引物无法识别，而且由于目前测序技术的局限性，紧靠测序引物一侧的30～50个bp通常也无法100％识别，如果需要验证这个区域的碱基序列或者测序引物本身的序列，就需要用另一侧引物进行反向测序。</p>
              <p>(2) 您提供的是质粒或菌液样品,使用通用引物测序，找不到您的PCR引物可能是因为您的PCR引物距离载体的通用引物位点过近，由于测序反应在距离起始位点30-50bp内的结果可信度不高，因此会影响您正确读取您的PCR引物序列。</p>
            </el-collapse-item>
            <el-collapse-item title="Q-7.我有一个长的片段，希望你们帮我测通，还有测通需要的时间。" name="7">
              <p>(1) 长度为1Kb的DNA模板需要两个测序反应，才有可能得到完整准确的读长，对于1.6kb以上的DNA片断，在两个反应后还需要设计合成测序引物，测序后拼接出全长，对于这些测序引物，我们将按碱基个数收取引物合成费用。</p>
              <p>(2) 测通需要的时间。</p>
              <p>a.如有预期片段的序列，可以一次做设计好引物做出实验方案， 3-5天发送结果；</p>
              <p>b.如没有预期的序列，可以从两端设计引物，引物合成时间需要48小时，测序需要48小时。</p>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>
    <div class="sanger-service main_bg">
      <div class="c-title">服务特色</div>
      <div class="container">
        <ul class="lists1">
          <li>
            <img src="@/assets/images/sanger_service_1.png">
            <p class="fz16 fb center-text">上门取样</p>
            <p>遍布全国的实验基地，近距离提供服务，随时上门取样，送样更省时</p>
          </li>
          <li>
            <img src="@/assets/images/sanger_service_2.png">
            <p class="fz16 fb center-text">生产自动化</p>
            <p>自动化覆盖生产全过程，层层提速，精准测序，准时出结果，方便实验安排</p>
          </li>
          <li>
            <img src="@/assets/images/sanger_service_3.png">
            <p class="fz16 fb center-text">服务智能化</p>
            <p>全渠道客服系统，全面触达各沟通渠道，支持多功能内容传输，7×24 H服务不掉线</p>
          </li>
          <li>
            <img src="@/assets/images/sanger_service_4.png">
            <p class="fz16 fb center-text">满足批量需求</p>
            <p>拥有百余台3730XL遗传分析仪，可满足大批量测序要求，服务更全面</p>
          </li>
        </ul>
      </div>
    </div>
    <qk-consult type="sanger"/>
    <!--在线订购-->
    <qk-online-order @order="toOrder"/>
    <!--在线咨询-->
    <qk-service/>
  </div>
</template>
<style scoped>
@import url("../../assets/sanger.css");
</style>
<script>
import OnlineOrder from '@/components/onlineOrder'
import bread from "@/components/bread"
export default {
  components: {
    bread,
    'qk-online-order': OnlineOrder
  },
  data () {
    return {
      currentType: -1,
      types: [{
        name: 'PCR产物测序', ref: ''
      }, {
        name: '菌液测序', ref: ''
      }, {
        name: '质粒测序', ref: ''
      }],
      activeNames: []
    }
  },
  methods: {
    toOrder () {
      this.$router.push('/tec/order_sanger')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/sanger.vue